module.exports = __webpack_public_path__ + "media/assets/icons/email-blue-31b6cf63e075608ac5685f9d21a5b88c.svg";